import React from 'react';

const buildInfo = {
    commit: process.env.REACT_APP_GIT_COMMIT || 'Unknown',
    branch: process.env.REACT_APP_GIT_BRANCH || 'Unknown',
    buildTime: process.env.REACT_APP_BUILD_TIME || new Date().toISOString()
};

const BuildInfoPage = () => (
    <div className="p-4 max-w-lg mx-auto bg-gray-100 rounded-lg shadow-md">
        <h1 className="text-xl font-bold">Build Information</h1>
        <ul className="mt-2 text-sm">
            <li>
                <strong>Commit:</strong> {buildInfo.commit}
            </li>
            <li>
                <strong>Branch:</strong> {buildInfo.branch}
            </li>
            <li>
                <strong>Build Time:</strong> {buildInfo.buildTime}
            </li>
        </ul>
    </div>
);

export default BuildInfoPage;
